import { useEffect } from "react";
import { api } from "@/lib/api";

export default function AdminTheme() {
  useEffect(() => {
    let style;
    api.get("/admin/themes?target=admin").then((response) => {
      const theme = response.data.find((item) => item.active);
      if (!theme?.content) return;
      style = document.createElement("style");
      style.dataset.adminTheme = theme.id;
      style.textContent = theme.format === "css" ? theme.content : `.admin{${Object.entries(JSON.parse(theme.content)).map(([key, value]) => `--${key}:${value};`).join("")}}`;
      document.head.appendChild(style);
    }).catch(() => {});
    return () => style?.remove();
  }, []);
  return null;
}